import { knownBackgroundColors } from './index';

export const DEFAULT_GRAY_COLOR: string = knownBackgroundColors[10];
